var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-center text-sm-left"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-justify"},[_vm._v(_vm._s(_vm.body))])])}
var staticRenderFns = []

export { render, staticRenderFns }